/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pb_LongestInputs */

const en_ui_pb_longest = /** @type {(inputs: Ui_Pb_LongestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longest`)
};

const de_ui_pb_longest = /** @type {(inputs: Ui_Pb_LongestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Längste`)
};

/**
* | output |
* | --- |
* | "Longest" |
*
* @param {Ui_Pb_LongestInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pb_longest = /** @type {((inputs?: Ui_Pb_LongestInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pb_LongestInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pb_longest(inputs)
	return de_ui_pb_longest(inputs)
});